import type { Announcement } from "../types";

export function onSchedule(announcements: Announcement[]) {
  return announcements.filter((announcement) => announcement.onSchedule);
}

export function onWelcome(announcements: Announcement[]) {
  return announcements.filter((announcement) => announcement.onWelcome);
}

export function onScreens(announcements: Announcement[]) {
  return announcements.filter((announcement) => announcement.onScreens);
}
